import { Col, Progress } from "reactstrap";
import { getNetworkDownloadSpeed } from "../networkSpeedTest/NetworkSpeedTestHelper";
import React, { useState, useEffect } from "react";
import { exerciseType } from "../../components/constants/constants";
import { includes } from "lodash";

export const SpeakNetWorkSpeedTest = ({ requirementdata, arr,SystemTextContent }) => {
  const [downloadingSpeed, SetDownloadingSpeed] = useState();
  let percentage = 0;
  let pClass = "danger";
  useEffect(() => {
    console.log("ghbjknlm;");
    
    if (!downloadingSpeed) {
    console.log("ghb", downloadingSpeed);
      getNetworkDownloadSpeed(SetDownloadingSpeed);
    }
  }, [downloadingSpeed]);

  if (downloadingSpeed) {
    percentage = (downloadingSpeed?.mbps / 3) * 100;
  }

  if (percentage >= 50 && percentage < 80) {
    pClass = "warning";
  } else if (percentage >= 80) {
    pClass = "success";
  }

  return (
    <div className="py-2 f-13">
      <>
        <div>
          <div className="boldText">{SystemTextContent.testInternet}</div>
        </div>
        <Col md={12}>
          <div className="">
            <div className="mt-2 justify-content-between">
              <div className="speak-pg-height mt-2 mb-2 me-4">
                <Progress className="col-9 col-lg-7" color={pClass} value={percentage} />{" "}
              </div>
              <div>
                {includes(arr, exerciseType.PRONUNCIATION_TASK) ? (
                  <i className="mt-3">
                    Your speed is
                    {downloadingSpeed
                      ? ` ${downloadingSpeed?.mbps} mb `
                      : " --- mb "}
                    per second. Required speed is 3 mb per second.
                  </i>
                ) : (
                  <i>
                    Your speed is
                    {downloadingSpeed
                      ? ` ${downloadingSpeed?.mbps} mb `
                      : " --- mb "}
                    per second. Required speed is 1 mb per second.
                  </i>
                )}
              </div>
            </div>
          </div>
        </Col>
      </>
    </div>
  );
};
